// import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据
import xdfRequest from '@xdf/request';

// 创建axios实例
const instance = xdfRequest({
  timeout: 1000 * 12,
});

// 添加响应拦截器，使其返回格式与 axios.request 一致
instance.interceptors.response.use(
  response => {
    // 直接返回响应体中的数据部分，与 axios.request 保持一致
    return response.data;
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default instance;
